<script setup>
const props = defineProps({
    title: {
        type: String,
        default: null,
    },
    text: {
        type: String,
        default: null,
    },
});
</script>

<template>
    <div class="container flex justify-center pt-12 md:pt-16" :class="{ 'pb-12 md:pb-16': text }" v-if="title || text">
        <div class="md:w-8/12">
            <h2 class="" :class="{ 'mb-0': !text }" v-html="title" v-if="title"></h2>

            <div
                class="max-w-full prose prose-a:transition-colors prose-a:font-bold text-bodyColor marker:text-primary prose-a:hover:text-primary"
                v-html="text"
                v-if="text"
            ></div>
        </div>
    </div>
</template>
